import React, { useState, useEffect } from "react";
import Carousel from "nuka-carousel";
import { Container } from "react-bootstrap";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCouponsBasedOnDomainAction } from "../../../../Store/CouponBaseOnDomain/actions";
import { getCouponByIdAction } from "../../../../Store/Coupons/actions";
import "../../../../Assets/Scss/newHome3.scss";
import { getImageUrlhttps } from "../../../../Utils/index";
import { getAdBannerByDomainAction } from "../../../../Store/actions";
import { getRecommendBannerAction } from "../../../../Store/Coupons/actions";
import {
  postNewsletteraction,
  resetNewsletterStateAction,
} from "../../../../Store/NewsLetter/action";
import { ToastContainer, toast } from "react-toastify";

function Deals({ match }) {
  const dispatch = useDispatch();

  const { couponbaseondomainList } = useSelector(
    (store) => store.CouponBasedOnDomain
  );
  const { link } = useSelector((state) => state.CouponUrl);
  const { getRecommendBanner } = useSelector((state) => state.Coupon);

  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newTab, setNewTab] = useState(false);

  const { couponByID } = useSelector((state) => state.Coupon);

  useEffect(() => {
    if (couponbaseondomainList.length === 0) {
      dispatch(getCouponsBasedOnDomainAction());
    }
  }, [couponbaseondomainList, dispatch]);

  useEffect(() => {
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id === undefined
    ) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id !== undefined
    ) {
      window.open(
        `/couponsredirect/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    localStorage.setItem("link", link);
    if (redirect) {
      setLoading(false);
      setNewTab(!newTab);
    }
    if (redirect2) {
      setLoading(false);
      setNewTab(!newTab);
    }
  }, [link, newTab, redirect, redirect2]);

  useEffect(() => {
    if (link && redirect) {
      setRedirect(false);
      window.open(`/meta-redirect/`, "_blank");
    }
    if (link && redirect2) {
      setRedirect2(false);
      window.open(link, "_blank");
    }
  }, [newTab, link, redirect, redirect2]);

  React.useEffect(() => {
    dispatch(getAdBannerByDomainAction());
  }, [dispatch]);

  const items2 = React.useMemo(() => {
    let arr = [];
    getRecommendBanner?.forEach((i) => {
      if (i.banner_dimension === "300 * 250") {
        let obj = {};
        obj.src = getImageUrlhttps(i.image_upload);
        obj.altText = "ad";
        arr.push(obj);
      }
    });
    return arr;
  }, [getRecommendBanner]);

  React.useEffect(() => {
    dispatch(getRecommendBannerAction({ dimension: "300 * 250" }));
  }, [dispatch]);

  const { successMessage, sucess, errorMessage } = useSelector(
    (state) => state.Newsletter
  );

  const [email_id, setEmail] = useState("");

  const validate = (email) => {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const handleNewsletter = () => {
    if (!validate(email_id)) {
      toast.error("Please provide a valid email address.");
      return;
    }
    dispatch(postNewsletteraction({ email_id }));
  };

  React.useEffect(() => {
    if (sucess) {
      toast.success(successMessage);
      dispatch(resetNewsletterStateAction());
    }

    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(resetNewsletterStateAction());
    }
  }, [loading, dispatch, errorMessage, successMessage, sucess]);

  return (
    <div style={{ background: "#f0f0f0" }} className="pt-0">
      <Container id="recommended-res-cards">
        <Row>
          <Col sm="12" md="4" style={{ marginTop: "1%" }}>
            <div className="rec-i2-mobile-margin" id="slider-i3-square">
              <Carousel>
                {items2
                  ?.slice(0, items2?.length - parseInt(items2?.length / 2))
                  .map((o) => {
                    return (
                      <img
                        className="cursor-pointer"
                        onClick={() => window.open(o?.redirect_url, "_blank")}
                        id="slider-img-s"
                        src={o.url || o.src}
                        alt={o.alt}
                        loading="lazy"
                        style={{ width: "100%", height: "370px" }}
                      />
                    );
                  })}
              </Carousel>
            </div>
          </Col>

          <Col sm="12" md="4" style={{ marginTop: "1%" }}>
            <div className="rec-i2-mobile-margin" id="slider-i3-square">
              <Carousel>
                {items2
                  ?.slice(parseInt(items2?.length / 2), items2?.length)
                  .map((o) => {
                    return (
                      <img
                        className="cursor-pointer"
                        onClick={() => window.open(o?.redirect_url, "_blank")}
                        id="slider-img-s"
                        src={o.url || o.src}
                        alt={o.alt}
                        loading="lazy"
                        style={{ width: "100%", height: "363px" }}
                      />
                    );
                  })}
              </Carousel>
            </div>
          </Col>

          <Col xl="4" sm="12">
            <div
              class="panel-container rec-i2-mobile-margin"
              style={{ color: "white", background: "#005e36" }}
            >
              <small style={{ color: "white" }}>
                Don't miss out the latest
              </small>
              <h3 style={{ color: "white" }}>
                Weekly Best Deals And Offers <br />
                straight to your inbox
              </h3>
              <input
                type="email"
                placeholder="Email address"
                value={email_id}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                style={{ color: "white", background: "#028950" }}
                onClick={() => handleNewsletter()}
              >
                Stay updated
              </button>
              <small>
                Commitment issues? <br />
                Unsubscribe at any time.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
      <br />

      <ToastContainer position="top-right" />
    </div>
  );
}

export default Deals;
